import { render, staticRenderFns } from "./SmsMergeFieldChip.vue?vue&type=template&id=1c0d057b&scoped=true"
import script from "./SmsMergeFieldChip.vue?vue&type=script&lang=js"
export * from "./SmsMergeFieldChip.vue?vue&type=script&lang=js"
import style0 from "./SmsMergeFieldChip.vue?vue&type=style&index=0&id=1c0d057b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d057b",
  null
  
)

export default component.exports